// pages/PlanosPagamento/SelecionarPlanoBasePage.jsx

import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { listarPlanosBase } from '../../services/planosPagamentoService'; // Importação nomeada
import { formatarMoeda } from '../../utils/formatters';

const SelecionarPlanoBasePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [planos, setPlanos] = useState([]);

  useEffect(() => {
    const loadPlanosBase = async () => {
      try {
        setLoading(true);
        const response = await listarPlanosBase();
        if (response.success) {
          // Se a API retorna { success: true, data: [...] }
          setPlanos(response.data);
        } else {
          setError('Erro ao carregar planos base');
        }
      } catch (err) {
        console.error('Erro ao carregar planos:', err);
        setError('Erro ao carregar planos base. Por favor, tente novamente.');
      } finally {
        setLoading(false);
      }
    };

    loadPlanosBase();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button variant="outlined" onClick={() => navigate('/planos-pagamento')}>
          Voltar para Planos
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <div>
          <Typography variant="h4" gutterBottom>
            Selecionar Plano Base
          </Typography>
          <Typography color="text.secondary">
            Selecione um plano base para vincular a um estudante
          </Typography>
        </div>
        <Button 
          variant="outlined" 
          onClick={() => navigate('/planos-pagamento')}
        >
          Voltar
        </Button>
      </Box>

      <Grid container spacing={3}>
        {planos.map((plano) => (
          <Grid item xs={12} md={6} lg={4} key={plano.id}>
            <Card>
              <CardContent>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    {plano.anoLetivo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {plano.descricao}
                  </Typography>
                </Box>

                <Typography variant="h5" color="primary" gutterBottom>
                  {formatarMoeda(plano.valorTotal)}
                </Typography>

                <Box sx={{ mt: 2, mb: 3 }}>
                  <Typography variant="body2">
                    Prestações: {plano.prestacoes?.length || 0}
                  </Typography>
                  <Typography variant="body2">
                    Início: {new Date(plano.dataInicio).toLocaleDateString()}
                  </Typography>
                  <Typography variant="body2">
                    Fim: {new Date(plano.dataFim).toLocaleDateString()}
                  </Typography>
                </Box>

                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => navigate(`/planos-pagamento/${plano.id}/vincular-estudante`)}
                >
                  Selecionar Plano
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}

        {planos.length === 0 && (
          <Grid item xs={12}>
            <Alert severity="info" sx={{ mb: 2 }}>
              Não há planos base disponíveis. Crie um plano base primeiro.
            </Alert>
            <Button
              variant="contained"
              onClick={() => navigate('/planos-pagamento/criar')}
            >
              Criar Plano Base
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default SelecionarPlanoBasePage;
